import React, { useEffect, useState } from "react";
import Modal from "components/modal";
import { BrightRiverShotItem } from "./bright-river-shot-item";
import LoaderButton from "components/loader/loader-button";
import * as notify from "shared/notify";
import { useDeleteEditedShots } from "shared/hooks/api/use-delete-edited-shots";

import "../photography.scss";

export const BrightRiverShotConfirmation = ({ corrections, show, onEditComplete }) => {
    const [open, setOpen] = useState(false);
    const [toggleAll, setToggleAll] = useState();
    const [selectedCorrections, setSelectedCorrections] = useState({});
    const selectedCorrectionsCount = Object.keys(selectedCorrections).filter((key) => selectedCorrections[key]).length;
    const { mutate: deleteUneditedShots, isLoading } = useDeleteEditedShots();

    useEffect(() => {
        if (show) {
            setOpen(true);
        }
    }, [show]);

    const handleSelectAll = () => setToggleAll(true);

    const handleUnselectAll = () => setToggleAll(false);

    const handleCorrectionUpdate = (name, isToggled) => {
        setSelectedCorrections((state) => ({ ...state, [name]: isToggled }));
    };

    const handleCancel = () => {
        setOpen(false);
        onEditComplete({ isEditComplete: false });
    };

    const handleSubmit = async () => {
        const itemIds = Object.keys(selectedCorrections).filter((key) => selectedCorrections[key]);

        if (itemIds.length) {
            await deleteUneditedShots(itemIds, {
                onSuccess: () => {
                    notify.success("Image(s) re-send successfully");
                    setOpen(false);
                    onEditComplete({ isEditComplete: true });
                },
            });

            return;
        }

        onEditComplete({ isEditComplete: true });
    };

    return (
        <Modal show={open} onClose={handleCancel}>
            <h4>Bright River Image Confirmation</h4>

            <div>
                The following images have Bright River editing sources <br />
                and associated edited images. Please select which <br />
                images should be re-send to Bright River for editing corrections.
            </div>

            <div className="justify-content-center editing-source-select -spaced">
                (<span className="count">{selectedCorrectionsCount} selected</span>
                <button className="button -text" onClick={handleSelectAll}>
                    Select All
                </button>
                <button className="button -text" onClick={handleUnselectAll}>
                    Deselect All
                </button>
                )
            </div>

            <div>
                {corrections.map(({ key, editedImageUris, uneditedImageUris, imageViewDescription, locale }) => {
                    return (
                        <BrightRiverShotItem
                            key={key}
                            name={key}
                            editedImgUrl={editedImageUris.small}
                            originalImgUrl={uneditedImageUris.small}
                            onCorrectionUpdate={handleCorrectionUpdate}
                            imageDescription={imageViewDescription}
                            forceChecked={toggleAll}
                            locale={locale}
                        />
                    );
                })}
            </div>
            <div className="button-group -space-between">
                <button className="button" onClick={handleCancel} disabled={isLoading}>
                    Cancel
                </button>
                <LoaderButton className="button -primary" isSubmitting={isLoading} onClick={handleSubmit} text="Continue" />
            </div>
        </Modal>
    );
};
